module.exports = __webpack_public_path__ + "img/module1_icon3.c33a2ff5.png";